import { render, staticRenderFns } from "./SubpageHeader.vue?vue&type=template&id=dc53b930&"
import script from "./SubpageHeader.vue?vue&type=script&lang=js&"
export * from "./SubpageHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubpageHeader.vue?vue&type=style&index=0&id=dc53b930&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports